import axios from "axios";
import config from "services/config";

const BASE = `${config.url}/indicators`;
const adminHeaders = () => ({ Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}` });

export const IndicatorsService = {
  async list({ year } = {}) {
    const { data } = await axios.get(BASE, { params: { year }, headers: adminHeaders() });
    return data;
  },
  async get(year, month) {
    const { data } = await axios.get(`${BASE}/${year}/${month}`, { headers: adminHeaders() });
    return data;
  },
  async upsertManual(year, month, payload) {
    const { data } = await axios.post(`${BASE}/${year}/${month}`, payload, { headers: adminHeaders() });
    return data;
  },
  async sync() {
    const { data } = await axios.post(`${BASE}/sync`, {}, { headers: adminHeaders() });
    return data;
  },
};
